module.exports = __webpack_public_path__ + "static/media/logo_xs.491bd86a.png";